export default "__VITE_PUBLIC_ASSET__4e39c8c3__"